import React from "react";
import { Checkbox, FilesPdfIcon, Flex, Text } from "@fluentui/react-northstar";
import styled from "styled-components/macro";
import { FolderFilled, FolderPersonFilled } from "@fluentui/react-icons";
import { ICON_FROM_EXTENSION } from "../../../../utils/functions";

const CellName = ({
    name = "",
    isFolder = false,
    isEmployeeFolder = false,
    checked = false,
    onClickName = () => null,
}) => {
    return (
        <Flex vAlign="center">
            <CheckboxStyle defaultChecked={checked} checked={checked} />
            <Flex gap="gap.smaller" vAlign="center">
                {isFolder && isEmployeeFolder && (
                    <FolderPersonFilled fontSize={20} />
                )}
                {isFolder && !isEmployeeFolder && (
                    <FolderFilled fontSize={20} />
                )}
                {!isFolder && ICON_FROM_EXTENSION(name, "large")}
                <TextName
                    content={name}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        onClickName();
                    }}
                />
            </Flex>
        </Flex>
    );
};

export default CellName;

export const CheckboxStyle = styled(Checkbox)`
    display: block;
`;
export const TextName = styled(Text)`
    color: var(
        --light-theme-rest-foreground-default-foreground-1424242,
        #424242
    );

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */

    :hover {
        text-decoration: underline;
    }
`;
